import { gql } from '@apollo/client';

export * from './app.query.generated';

export const APP = gql`
  query app($appId: ID!) {
    app(appId: $appId) {
      id
      name
      description
      logoUrl
      criticality
      creator {
        name
      }
      industry
      jurisdiction
      softwareType
      kind
      owned
      ownerName
      ownerWebsite
      unclaimed
      includedApps
      createdAt
      updatedAt
      taskCounts {
        criticality
        count
      }
      policy {
        read
        update
        createBackup
        createEscrow
        createCustodianProfile
        createMemberships
        linkProducts
        readMemberships
        remove
      }
    }
  }
`;
